import {Flex} from "antd";
import {translations} from "./Translations";
import {getLangFromUrl} from "./Header";
import "./main.css";

export const Flow = () => {
    const lang = getLangFromUrl();

    return (
        <div className={"flow-wrapper"}>
            <Flex className={"how-it-works"} vertical={true} align={'center'}>
                <div className="games-section-title">{translations[lang].how}</div>
                <div className="games-section-subtitle">{translations[lang].howText}</div>

                <Flex className={"flow-container"}>
                    <Flex gap={10} align={'center'} className={"flow-step"}>
                        <img src={"/idea.svg"} className={"flow-icon"}/>
                        <Flex vertical={true} gap={10} className={"flow-step-text"}>
                            <div className={'flow-title'}>{translations[lang].idea}</div>
                            <div className={'flow-text'}>{translations[lang].ideaText}</div>
                        </Flex>
                    </Flex>
                    <div className={'flow-arrow'}><img src={"/arrow.svg"}/></div>
                    <Flex gap={10} align={'center'} className={"flow-step"}>
                        <img src={"/design.svg"} className={"flow-icon sm"}/>
                        <Flex vertical={true} gap={10} className={"flow-step-text"}>
                            <div className={'flow-title'}>{translations[lang].design}</div>
                            <div className={'flow-text'}>{translations[lang].designText}</div>
                        </Flex>
                    </Flex>

                    <div className={'flow-arrow'}><img src={"/arrow.svg"}/></div>
                    <Flex gap={10} align={'center'} className={"flow-step"}>
                        <img src={"/prototype.svg"} className={"flow-icon sm"}/>
                        <Flex vertical={true} gap={10} className={"flow-step-text"}>
                            <div className={'flow-title'}>{translations[lang].prototype}</div>
                            <div className={'flow-text'}>{translations[lang].prototypeText}</div>
                        </Flex>
                    </Flex>

                    <div className={'flow-arrow'}><img src={"/arrow.svg"}/></div>
                    <Flex gap={10} align={'center'} className={"flow-step"}>
                        <img src={"/test.svg"} className={"flow-icon sm"}/>
                        <Flex vertical={true} gap={10} className={"flow-step-text"}>
                            <div className={'flow-title'}>{translations[lang].test}</div>
                            <div className={'flow-text'}>{translations[lang].testText}</div>
                        </Flex>
                    </Flex>

                    <div className={'flow-arrow'}><img src={"/arrow.svg"}/></div>
                    <Flex gap={10} align={'center'} className={"flow-step"}>
                        <img src={"/production.svg"} className={"flow-icon sm"}/>
                        <Flex vertical={true} gap={10} className={"flow-step-text"}>
                            <div className={'flow-title'}>{translations[lang].production}</div>
                            <div className={'flow-text'}>{translations[lang].productionText}</div>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
        </div>
    )
}